var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon16PxEditFilled(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6504 7.35352L5.29297 13.7109C5.10547 13.8984 4.85107 14.0039 4.58594 14.0039H2.5C2.22396 14.0039 2.00016 13.7799 2 13.5039V11.418C2 11.1528 2.10548 10.8985 2.29297 10.7109L8.65039 4.35352L11.6504 7.35352ZM10.29 2.70703C10.6805 2.31653 11.3136 2.31658 11.7041 2.70703L13.2881 4.29102C13.6786 4.68154 13.6786 5.31455 13.2881 5.70508L12.3477 6.64551L9.34961 3.64746L10.29 2.70703Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon16PxEditFilled);
export default __webpack_public_path__ + "static/media/icon_16px_edit_filled.fb0d277bc40f155fe4546f68c3e38b85.svg";
export { ForwardRef as ReactComponent };